<template>
  <div class="video-box" :style="`padding: ${padding};`">
    <div class="video-in">
      <!-- <div class="video-kv" v-show="liveState!==2">
        <img :src="poster" alt="">
      </div> -->
      <video
        :id="`my-video${id}`"
        class="my-video video-js vjs-default-skin vjs-big-play-centered"
        controls
        :webkit-playsinline="true"
        :playsinline="true"
        :poster="poster"
        :width="width"
        preload="auto"
      >
        <!-- <source src="https://p6.vzan.com/290332/736826529958881216/live.m3u8?zbid=290332&tpid=2006557082"/> -->
      </video>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js';
import 'videojs-contrib-hls';
import { mapGetters } from 'vuex'
import { nanoid } from 'nanoid'
export default {
  data() {
    return {
      player: null,
      isTrue: true,
      timer: null,
      id: null,
      liveAddress: []
    }
  },
  computed: {
    ...mapGetters(['liveState'])
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    liveInfo: {
      type: Object,
      default: () => {
        return {
          live: {},
          liveStream: {}
        }
      }
    },
    poster: {
      type: String,
      default: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_d4599d99b2ae40de8f04dd39982f2c38.jpg'
    },
    padding: {
      type: String,
      default: ''
    }
  },
  watch: {
    poster(n) {
      if (this.player) {
        this.player.setAttribute('poster', n);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.id = nanoid()
      setTimeout(() => {
        this.getVideo();
      }, 200)
    });
  },
  methods: {
    getVideo() {
      this.player = videojs(`my-video${this.id}`, {
        bigPlayButton: true, // 显示播放按钮
        textTrackDisplay: false,
        posterImage: true,
        errorDisplay: false,
        controlBar: true // 显示控件
      }, that => {
        // this.player.etAttribute('poster', this.poster);
      })
    },
    play(src) {
      this.player.src(src)
      this.player.play()
    },
    pause() {
      this.player.pause()
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
      this.player = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .video-box {
    // position: absolute;
    width: 100%;
    height: 100%;
    // top: 0;
    // left: 0;
    box-sizing: border-box;
    .video-in {
      display: flex;
      width: 100%;
      height: 100%;
      position: relative;
    }
    .my-video {
      margin: auto;
      width: 100%;
      height: 100%;
    }
    ::v-deep .video-js .vjs-big-play-button {
        font-size: 6em !important;
        color: rgba(255, 255, 255, .5) !important;
        background: none;
        border: none;
      }
  }
  .video-kv {
    width: 100%;
    height: 100%;
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  ::v-deep .vjs-poster {
    background-size: 100% 100% !important;
  }
  .swiper-button-next, .swiper-button-prev {
    margin-top: calc(0px - (var(--swiper-navigation-size) / 1.2)) !important;
  }
</style>
